<template>
  
    <div class="content">
      <v-flex align-self-center>
      <h2>中标公告</h2>
      </v-flex>
      <v-flex>
        <article>
          <img class="img" src="https://qihuibao.oss-cn-beijing.aliyuncs.com/comps/zjczbgg.jpg" alt="">
        </article>
      </v-flex>
    </div>
  
</template>
<script>
export default {
  data() {
    return {};
  },
  
};
</script>
<style lang="scss" scoped>
// @media only screen and (min-width: 1280px){
//   .about{
//     .container {
//       max-width: 900px !important;
//     }
//   }
// }
.content {
  border-left: 1px solid #e4e4e4;
  padding-left:20px;
  margin-bottom: 40px;
  margin-top: 60px;
  h2 {
    margin-top: 0;
    font-size: 36px;
    font-weight: 400;
    text-align: center;
   
  }
  h3 {
    text-align: center;
  }
  .img{
      width:100%;  
  }
}
article p {
  text-indent: 2em;
  font-size: 16px;
  color: #666;
}

// .about-header {
//   width: 100%;
//   height: 377px;
//   background: url("/images/about/about-bg.png") no-repeat center center;
//   background-size: cover;
//   text-align: center;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   p {
//     font-size: 30px;
//     font-weight: 500;
//     color: #fff;
//   }
// }
// @media screen and (max-width: 600px) {
//   .about-header p{
//     font-size:28px ;
//   }
//   .about {
//     h2 {
//       font-size: 26px;
//       font-weight: 400;
//       margin-bottom: 18px;
//       margin-top: 50px;
//     }
//   }
  
//   article,.about-img,.contact{
//     padding: 0 15px;
//   }
// }
</style>